module.exports = __webpack_public_path__ + "static/media/sales.f61111f1.PNG";